const gifTypes = {
  gif: 1,
  sticker: 2,
};

export default gifTypes;
